import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs/index";
import {CommonDataService} from "../common/common-data.service";
import {ContactPreference} from "./edit-contact-preferences/contact-preference";
import {AdditionalContact} from "./additional-contacts/additional-contact";
import {NafContactPreference} from "./edit-contact-preferences/naf-contact-preference";


@Injectable()
export class AboutMeService {

  constructor(private httpClient: HttpClient, private commonDataService: CommonDataService) {}

  updatePassword(userName: string, currentPassword: string, inputPassword: string, brand: string): Observable<any> {
    let data = {
      userName: userName,
      oldPassword: currentPassword,
      newPassword: inputPassword,
      brand: brand
    }
    return this.httpClient.put<any>('/api/aboutMe/updatePassword', data);
  }

  updateUserDetails(updateMeForm: any): Observable<any> {
    const billingAccountIdAndMobileServiceIdArray = this.commonDataService.serviceDetailsList.filter(service => service.active && service.serviceIsMobile).map(service => {
      return {
        billingAccountId: service.billingAccountId,
        serviceId: service.serviceId
      }
    });
    return this.httpClient.put<any>(`/api/aboutMe/updateUserDetails/${this.commonDataService.user.billingAccountId}`, [updateMeForm, billingAccountIdAndMobileServiceIdArray]);
  }

  getContactPreferencesForUser(): Observable<ContactPreference[]> {
    return this.httpClient.get<ContactPreference[]>(`/api/aboutMe/getContactPreferences/${this.commonDataService.user.billingAccountId}`);
  }

  updateContactPreferences(contactPreferences: ContactPreference[]): Observable<boolean> {
    return this.httpClient.post<boolean>(`/api/aboutMe/updateContactPreferences/${this.commonDataService.user.billingAccountId}`, contactPreferences);
  }

  getNafContactPreferences(): Observable<NafContactPreference[]> {
    return this.httpClient.get<NafContactPreference[]>(`/api/aboutMe/getNafContactPreferences/${this.commonDataService.user.billingAccountId}`);
  }

  updateNafContactPreferences(nafContactPreferences: NafContactPreference[]): Observable<boolean> {
    return this.httpClient.post<boolean>(`/api/aboutMe/updateNafContactPreferences/${this.commonDataService.user.billingAccountId}`, nafContactPreferences);
  }

  getAdditionalContacts(): Observable<AdditionalContact[]> {
    return this.httpClient.get<AdditionalContact[]>(`/api/aboutMe/getAdditionalContactList/${this.commonDataService.user.billingAccountId}`);
  }

  updateAdditionalContact(additionalContact: AdditionalContact): Observable<boolean> {
    return this.httpClient.post<boolean>(`/api/aboutMe/updateAdditionalContact/${this.commonDataService.user.billingAccountId}`, additionalContact);
  }

  addAdditionalContact(additionalContact: AdditionalContact) : Observable<boolean> {
    return this.httpClient.post<boolean>(`/api/aboutMe/addAdditionalContact/${this.commonDataService.user.billingAccountId}`, additionalContact);
  }

  deleteAdditionalContact(additionalContactId: string) : Observable<boolean> {
    return this.httpClient.post<boolean>(`/api/aboutMe/deleteAdditionalContact/${this.commonDataService.user.billingAccountId}/${additionalContactId}`, null)
  }
}
